export const PLUME_INCENTIVES_WITHDRAW_TEXT = 'Withdraw anytime, wait 90 days to earn PLUME incentives';
export const TOTAL_BALANCE_TOOLTIP_TEXT =
  'Total Balance is your Vault Position + Royco Position + PLUME Earnings in USD';
